import React from 'react';

const InfoPanel = ({ temaActual, semanaRepaso, vueltasCompletadas }) => {
  return (
    <div className="repaso-header">
      <div className="repaso-info-panel">
        <div className="repaso-icon">
          <i className="fas fa-book"></i>
        </div>
        <div className="repaso-info">
          <h3>Repaso Informática</h3>
          <div className="repaso-stats">
            <div className="stat-item">
              <i className="fas fa-calendar-alt"></i>
              <span>Tema {temaActual || 1} de 6</span>
            </div>
            <div className="stat-item">
              <i className="fas fa-list-alt"></i>
              <span>Semana {(semanaRepaso === 0 || semanaRepaso === null) ? 1 : semanaRepaso + 1} de 6</span>
            </div>
            <div className="stat-item">
              <i className="fas fa-check-circle"></i>
              <span>Vueltas completadas: {vueltasCompletadas}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;